import PageWrapper from 'components/utils/PageWrapper';
import Login from 'pages/Login';

export const loginRoutes = {
    path: '/login',
    element: (
        <PageWrapper titleId="login_sign_in_title">
            <Login />
        </PageWrapper>
    ),
};
